import { useContext } from 'react';
import { ValuesChartsDataContext } from '../contexts/ValuesChartsDataContext';

export const useValuesChartsDataContext = () => {
    return useContext(ValuesChartsDataContext);
};
